import {
  faArrowsRotate,
  faCircleCheck,
  faClipboard,
  faEdit,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { get, maxBy, uniqBy } from 'lodash'
import { Calendar } from 'primereact/calendar'
import { Checkbox, CheckboxChangeParams } from 'primereact/checkbox'
import { Column, ColumnBodyOptions } from 'primereact/column'
import {
  DataTable,
  DataTableColReorderParams,
  DataTableColumnResizeEndParams,
} from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectForceReloadProject,
  updateForceReloadProject,
  updateOrderlineCOETracker,
  updateProjectLevelContributors,
  updateRefreshProjectId,
  upsertOrderlineDetailsList,
} from '../../../features/projectManagement/projectManagementSlice'
import { ProjectManagementPmrWrapper } from '../../../features/projectManagementPmr/prohectManagementPmrSliceInterfaces'
import {
  generateGlobalSearchFilters,
  selectShowHideColumnProjectsOrderLine,
  updateShowHideColumnByTable,
} from '../../../features/projectManagementPmr/projectManagementPmrSlice'
import usePmrCurrency from '../../../hooks/usePmrCurrency'
import useProjectOrderlineDetail from '../../../hooks/useProjectOrderlineDetail'
import useToastr from '../../../hooks/useToastr'
import ProjectService from '../../../services/ProjectService'
import { formatDateWithTimezone } from '../../../shared/date-helper/DateHelper'
import {
  projectDetailsOrderlineListColumnFlexProjectEcd,
  projectDetailsOrderlineListColumnInvoicePrice,
  projectDetailsOrderlneListColumnAction,
  projectDetailsOrderlneListColumnAdditionalInfo,
  projectDetailsOrderlneListColumnApplicationType,
  projectDetailsOrderlneListColumnCertificationScheme,
  projectDetailsOrderlneListColumnCheckbox,
  projectDetailsOrderlneListColumnCrcd,
  projectDetailsOrderlneListColumnCustomerRemarks,
  projectDetailsOrderlneListColumnDeliveryPath,
  projectDetailsOrderlneListColumnEcd,
  projectDetailsOrderlneListColumnFlexHandler,
  projectDetailsOrderlneListColumnFlexHandlerEmail,
  projectDetailsOrderlneListColumnFlexTemplate,
  projectDetailsOrderlneListColumnGmaWbHandler,
  projectDetailsOrderlneListColumnGmaWbHandlerEmail,
  projectDetailsOrderlneListColumnGmawbTemplate,
  projectDetailsOrderlneListColumnLeadTime,
  projectDetailsOrderlneListColumnPrice,
  projectDetailsOrderlneListColumnStatus,
  projectDetailsOrderlneListColumnTechnology,
  projectDetailsOrderlneListColumnUlRemarks,
  projectDetailsOrderlineListColumnOrderlineNumber,
} from '../data/project-details-orderline-list-grid-columns'
import { GridColumnModel } from '../data/project-grid-columns'
import CustomerVisibleIndicator from '../shared/components/customer-visible-indicator/CustomerVisibleIndicator'
import PmrBulkEcdEditDialog from '../shared/components/pmr-bulk-ecd-edit-dialog/PmrBulkEcdEditDialog'
import PmrBulkHandlerReassignmentDialog from '../shared/components/pmr-bulk-handler-reassignment-dialog/PmrBulkHandlerReassignmentDialog'
import PmrEcdSingleEditTemplate from '../shared/components/pmr-ecd-single-edit-template/PmrEcdSingleEditTemplate'
import PmrHandlerTooltip from '../shared/components/pmr-handler-tooltip/PmrHandlerTooltip'
import {
  MismatchECDDataModel,
  ProjectOrderlineMismatchECDDialog,
} from '../shared/components/project-orderline-mismatch-ecd-dialog/ProjectOrderlineMismatchECDDialog'
import ProjectOrderlineRemarksTemplate from '../shared/components/project-orderline-remarks-template/ProjectOrderlineRemarksTemplate'
import ProjectOrderlineStatusBulkEditDialog from '../shared/components/project-orderline-status-bulk-edit-dialog/ProjectOrderlineStatusBulkEditDialog'
import ProjectOrderlineStatusTemplate from '../shared/components/project-orderline-status-template/ProjectOrderlineStatusTemplate'
import ProjectSingleCollaboratorAvatarReassign from '../shared/components/project-single-collaborator-avatar-reassign/ProjectSingleCollaboratorAvatarReassign'
import RemarksTypesEnum from '../shared/components/remarks-history-dialog/RemarksTypeEnum'
import HandlerType from '../shared/enums/handler-type'
import ProjectOrderlineStatus from '../shared/enums/project-orderline-status'
import { useProjectOrderLines } from '../shared/hooks/useProjectOrderLines'
import PmrE2EProjectDetailsOrderlineModel, {
  E2EProjectLineModelInfo,
  E2EProjectLineTechnology,
  getProjectLineIsCompletedV2,
  isRowUpdating,
} from '../shared/interfaces/pmr-e2e-project-details-orderline-model'
import PmrE2EProjectModel from '../shared/interfaces/pmr-e2e-project-model'
import InvoicePriceModal from './invoice-price-modal/InvoicePriceModal'
import InvoicePriceTemplate from './invoice-price-template/InvoicePriceTemplate'
import ManilaCoeTrackerForm from '../manila-coe-tracker/ManilaCoeTrackerForm'
import classes from './ProjectDetailsOrderLineList.module.scss'
import { IManilaCoeTrackerDetails } from '../shared/interfaces/manila-coe-tracker'

interface ProjectDetailsOrderLineListProps {
  projectId: string
  project: PmrE2EProjectModel
}

export interface HandlerEditState {
  orderLineId: string
  isFlexHandlerEdit: boolean
  isGmawbHandlerEdit: boolean
}

interface HandlerBulkEdit {
  isShowHandlerBulkEdit: boolean
  handlerType: HandlerType | null
}

interface ECDBulkEdit {
  isShowECDBulkEdit: boolean
  isOrderlineECD: boolean
}

const ProjectDetailsOrderLineList = (props: ProjectDetailsOrderLineListProps) => {
  const dispatch = useDispatch()
  const datatableRef = useRef<any>(null)
  const [loading, setLoading] = useState(false)
  const selectOrderLineColumns = useSelector(selectShowHideColumnProjectsOrderLine)
  const [columns, setColumns] = useState<GridColumnModel[]>([])
  const generatedGlobalFilters = useSelector<
    ProjectManagementPmrWrapper,
    { label: string; value?: any }[]
  >(state => generateGlobalSearchFilters(state, props.projectId))

  const [selectAll, setSelectAll] = useState(false)
  const [isBulkEditDialogShow, setIsBulkEditDialogShow] = useState(false)
  const [bulkEcdEditState, setBulkEcdEditState] = useState<ECDBulkEdit>({
    isOrderlineECD: true,
    isShowECDBulkEdit: false,
  })
  const [selectedOrderLineIdInvoicePrice, setSelectedOrderLineIdInvoicePrice] = useState<
    PmrE2EProjectDetailsOrderlineModel[]
  >([])
  const [isOrderlineMismatchECDDialogShow, setIsOrderlineMismatchECDDialogShow] = useState(false)
  const { orderLines, validSelectedRows, orderlineDetailList } = useProjectOrderLines(
    props.projectId
  )
  const projectOrderlineDetailHook = useProjectOrderlineDetail(props.projectId)

  const [handlerEditState, setHandlerEditState] = useState<HandlerEditState[]>([])
  const [showHandlerBulkDialogVisible, setShowHandlerBulkDialogVisible] =
    useState<HandlerBulkEdit>()

  const [mismatchECDData, setMismatchECDData] = useState<MismatchECDDataModel | null>(null)

  const { showSuccess, showError } = useToastr()

  const forceReloadProject = useSelector(selectForceReloadProject)
  const { loadCurrencies } = usePmrCurrency()

  const [isDisabledBulkEditIcon, setIsDisabledBulkEditIcon] = useState<boolean>(true)
  const [isDisplayManilaCoeTrackerForm, setDisplayManilaCoeTrackerForm] = useState<boolean>(false)
  const [targetOrderline, setTargetOrderline] = useState<IManilaCoeTrackerDetails>()

  useEffect(() => {
    getList()
    loadCurrencies()
  }, [])

  useEffect(() => {
    if (handlerEditState.length > 0) return

    setHandlerEditState(
      (
        orderlineDetailList.find(list => list.projectId === props.projectId)?.orderlineDetailList ||
        []
      ).map(orderLine => {
        return {
          orderLineId: orderLine.id,
          isFlexHandlerEdit: false,
          isGmawbHandlerEdit: false,
        }
      })
    )
  }, [orderlineDetailList])

  useEffect(() => {
    setColumns(selectOrderLineColumns!.fields)
  }, [selectOrderLineColumns])

  useEffect(() => {
    if (datatableRef.current) {
      datatableRef.current.restoreColumnWidths()
      datatableRef.current.reset()
    }
  }, [columns])

  useEffect(() => {
    if (forceReloadProject === true) {
      getList()
      dispatch(updateForceReloadProject(false))
    }
  }, [forceReloadProject])

  useEffect(() => {
    setIsDisabledBulkEditIcon(validSelectedRows().length === 0)
  }, [orderLines])

  const onEcdUpdate = () => {
    getList()
    dispatch(updateRefreshProjectId(props.projectId))
  }

  const getList = async () => {
    setLoading(true)

    const response = await ProjectService.getOrderLineListDetails(props.projectId)

    if (response?.isSuccess && response?.data) {
      let records = formatList(response?.data)

      updateSelectAllCheckbox(records)

      dispatch(
        upsertOrderlineDetailsList({
          projectId: props.projectId,
          orderlineDetailList: records,
        })
      )
    }
    setLoading(false)
  }

  const updateSelectAllCheckbox = (records: PmrE2EProjectDetailsOrderlineModel[]) => {
    if (selectAll) {
      records.forEach(record => {
        record.isChecked = true
      })
    } else {
      updateRowCheckBox(records)
    }
  }

  const updateRowCheckBox = (records: PmrE2EProjectDetailsOrderlineModel[]) => {
    const rows = validSelectedRows()

    records.forEach(record => {
      const isInRows = rows.some(row => row.id === record.id)
      record.isChecked = isInRows
    })
  }

  const formatList = (list: PmrE2EProjectDetailsOrderlineModel[]) => {
    const productTypeKey = 'productType'
    return list.map((orderLine: PmrE2EProjectDetailsOrderlineModel, index: number) => {
      orderLine.isChecked = false
      orderLine.orderLineCRCD = formatDateWithTimezone(orderLine.orderLineCRCD)
      orderLine.orderLineECD = formatDateWithTimezone(orderLine.orderLineECD)
      orderLine.previousECD = formatDateWithTimezone(orderLine.previousECD)
      orderLine.modelNameCsv = orderLine.e2EProjectLineModelInfos
        ?.map((model: E2EProjectLineModelInfo) => model.modelName)
        .join(', ')
      const uniqProductType = uniqBy(orderLine.e2EProjectLineModelInfos, productTypeKey)
      orderLine.productTypesCsv = uniqProductType
        ?.map((model: E2EProjectLineModelInfo) => model.productType)
        .sort((a, b) => a.localeCompare(b))
        .join(', ')
      orderLine.technologyCsv = orderLine.technologies
        ?.map((technology: E2EProjectLineTechnology) => technology.technologyName)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        .join(', ')
      orderLine.orderLineNumber = setOrderLineNumber(orderLine)
      return orderLine
    })
  }

  const setOrderLineNumber = (orderLine: PmrE2EProjectDetailsOrderlineModel) => {
    return orderLine?.orderLineNumber
  }

  const isBulkActionRow = (rowData: PmrE2EProjectDetailsOrderlineModel) => rowData.id == '0'

  const bulkEditIconStyle: CSSProperties = isDisabledBulkEditIcon
    ? { marginLeft: '5px', opacity: 0.5, cursor: 'default' }
    : { marginLeft: '5px', cursor: 'pointer' }

  const handleSelectAllCheck = (event: CheckboxChangeParams) => {
    const isChecked = event.checked
    setSelectAll(isChecked)
    projectOrderlineDetailHook.updateSelectAllCheck(isChecked)
  }

  const handleRowCheck = (
    event: CheckboxChangeParams,
    rowData: PmrE2EProjectDetailsOrderlineModel
  ) => {
    projectOrderlineDetailHook.updateRowCheck(rowData, event.checked)
    const isAllSelected =
      orderLines.filter(x => x.id !== rowData.id).every(x => x.isChecked) && event.checked
    setSelectAll(isAllSelected)
  }

  const handleUpdateTargetOrderline = () => {
    dispatch(
      updateOrderlineCOETracker({
        id: targetOrderline?.e2eProjectLineId,
      })
    )
  }

  const handleBulkEditHandler = (handlerType: HandlerType) => {
    if (validSelectedRows().length > 0) {
      const hasEditStateFLEX = handlerEditState.some(handlerState => handlerState.isFlexHandlerEdit)
      const hasEditStateGMAWB = handlerEditState.some(
        handlerState => handlerState.isGmawbHandlerEdit
      )
      const columnWidthToAddOnEdit: number = 150

      setShowHandlerBulkDialogVisible({
        isShowHandlerBulkEdit: true,
        handlerType: handlerType,
      })

      const showHideCopyOrderLineList = structuredClone(selectOrderLineColumns)

      showHideCopyOrderLineList?.fields.map(field => {
        if (field.id === projectDetailsOrderlneListColumnFlexHandler && hasEditStateFLEX) {
          const getWidthAsNumber: number = Number(field.width.slice(0, field.width.indexOf('px')))
          field.width = `${getWidthAsNumber - columnWidthToAddOnEdit}px`
          field.widthNum = field.widthNum - columnWidthToAddOnEdit
        }

        if (field.id === projectDetailsOrderlneListColumnGmaWbHandler && hasEditStateGMAWB) {
          const getWidthAsNumber: number = Number(field.width.slice(0, field.width.indexOf('px')))
          field.width = `${getWidthAsNumber - columnWidthToAddOnEdit}px`
          field.widthNum = field.widthNum - columnWidthToAddOnEdit
        }

        return field
      })

      const resetHandlerEditState = handlerEditState.map(handlerState => {
        handlerState.isFlexHandlerEdit = false
        handlerState.isGmawbHandlerEdit = false

        return handlerState
      })

      setHandlerEditState(resetHandlerEditState)

      dispatch(
        updateShowHideColumnByTable({
          key: showHideCopyOrderLineList?.key,
          newColumns: showHideCopyOrderLineList?.fields,
          frozenCount: showHideCopyOrderLineList?.frozenColumnCount,
        })
      )
    }
  }

  const resetSelectedLines = () => {
    setSelectAll(false)
    projectOrderlineDetailHook.updateSelectAllCheck(false)
    updateHandlers()
  }

  const updateHandlers = () => {
    dispatch(updateRefreshProjectId(props.projectId))
    handlerUpdateProjectLevelContributors()
  }

  const handlerUpdateProjectLevelContributors = async () => {
    const response = await ProjectService.getProjectContributorsList(props.projectId)
    if (response.isSuccess) {
      dispatch(
        updateProjectLevelContributors({
          e2eProjectId: props.projectId,
          projectHandlers: response.data.projectHandlers,
        })
      )
    }
  }

  const tableColumnHeader = (col: GridColumnModel) => {
    return (
      <div>
        <span title={col.value}>
          {col.isCustomerVisible ? (
            <CustomerVisibleIndicator>{col.value}</CustomerVisibleIndicator>
          ) : (
            col.value
          )}
        </span>
      </div>
    )
  }

  const tableColumnBodyDefaultTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    return (
      <div
        title={get(rowData, col.field)}
        className={clsx(
          `text-container-ellipsis`,
          getProjectLineIsCompletedV2(rowData.orderLineStatus) &&
            classes['project-line-is-completed']
        )}
      >
        {get(rowData, col.field)}
      </div>
    )
  }

  const handleShowForm = (orderline: PmrE2EProjectDetailsOrderlineModel) => {
    setDisplayManilaCoeTrackerForm(true)
    setTargetOrderline({
      e2eProjectLineId: orderline.id,
      lineNumber: orderline.orderLineNumber ?? '',
      orderNumber: orderline.orderNumber ?? '',
      hasComment: orderline.hasComment,
    })
  }

  const tableColumnBody = (rowData: PmrE2EProjectDetailsOrderlineModel, col: ColumnBodyOptions) => {
    if (isBulkActionRow(rowData)) return <></>
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const orderlineNumberColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData)) return <></>

    return (
      <div
        title={get(rowData, col.field)}
        onClick={() => handleShowForm(rowData)}
        className={clsx(
          classes['orderline-tracker-link'],
          `cursor-pointer`,
          `gmawb-clickable-ui`,
          getProjectLineIsCompletedV2(rowData.orderLineStatus) &&
            classes['project-line-is-completed']
        )}
      >
        <span className="text-container-ellipsis">{get(rowData, col.field)}</span>
        {rowData.hasComment && (
          <FontAwesomeIcon
            icon={faClipboard}
            className={classes['orderline-tracker-icon']}
            title="Open Manila COE Tracker Form"
          />
        )}
      </div>
    )
  }

  const checkboxColumnHeaderTemplate = (col: GridColumnModel) => {
    return (
      <>
        <Checkbox
          checked={selectAll}
          onChange={(event: CheckboxChangeParams) => handleSelectAllCheck(event)}
          className={`${classes['project-checkbox']}`}
        />
      </>
    )
  }

  const actionColumnHeaderTemplate = (col: GridColumnModel) => {
    return (
      <>
        <div className={`${classes['action-column-container']}`}></div>
      </>
    )
  }

  const actionColumnBodyTemplate = (rowData: PmrE2EProjectDetailsOrderlineModel) => {
    return (
      <>
        {rowData.isMismatchECD && (
          <div className={`${classes['project-arrows-rotate-div']}`}>
            <FontAwesomeIcon
              title="The ECDs have been updated, and the order line schedule has been recalibrated."
              onClick={(event: any) => handleOrderLineSetMismatchECD(rowData)}
              icon={faArrowsRotate}
              className={`${classes['project-arrows-rotate']} gmawb-clickable-ui`}
            />
          </div>
        )}
      </>
    )
  }

  const checkboxColumnBodyTemplate = (rowData: PmrE2EProjectDetailsOrderlineModel) => {
    if (isBulkActionRow(rowData)) return <></>
    return (
      <>
        <div className={`${classes['project-checkbox-div']}`}>
          {!getProjectLineIsCompletedV2(rowData.orderLineStatus) && (
            <Checkbox
              checked={rowData.isChecked}
              onChange={(event: CheckboxChangeParams) => handleRowCheck(event, rowData)}
              disabled={getProjectLineIsCompletedV2(rowData.orderLineStatus)}
              style={{
                opacity: getProjectLineIsCompletedV2(rowData.orderLineStatus) ? 0.5 : 1,
              }}
              className={`${classes['project-checkbox']}`}
            />
          )}

          {getProjectLineIsCompletedV2(rowData.orderLineStatus) && (
            <span className={classes['check-icon']}>
              <FontAwesomeIcon icon={faCircleCheck} />
            </span>
          )}
        </div>
      </>
    )
  }

  const statusColumnHeaderTemplate = (col: GridColumnModel) => {
    return (
      <>
        <div className={`${classes['action-column-container']}`}>
          <span>Order Line Status</span>
          <FontAwesomeIcon
            className={clsx(
              { 'gmawb-clickable-ui': !isDisabledBulkEditIcon },
              { 'gmawb-clickable-ui-disabled': isDisabledBulkEditIcon }
            )}
            title="Bulk Edit"
            icon={faEdit}
            style={bulkEditIconStyle}
            onClick={() => {
              if (validSelectedRows().length > 0) setIsBulkEditDialogShow(true)
            }}
          />
        </div>
      </>
    )
  }

  const handlersColumnHeaderTemplate = (col: GridColumnModel) => {
    let handlerType: HandlerType | null = null
    if (col.id === projectDetailsOrderlneListColumnFlexHandler)
      handlerType = HandlerType.FlexHandler

    if (col.id === projectDetailsOrderlneListColumnGmaWbHandler)
      handlerType = HandlerType.GmaWBHandler

    const hasMailDraft =
      handlerType === HandlerType.GmaWBHandler &&
      validSelectedRows().some(vsr => !!vsr.handlerAssignmentDraft)

    return (
      <>
        <div className={`${classes['action-column-container']}`}>
          <PmrHandlerTooltip handlerType={handlerType} target={`.${col.id}-header`} />
          <span className={`${col.id}-header`}>
            {col.isCustomerVisible ? (
              <CustomerVisibleIndicator suppressTooltip={true}>
                {col.value}
              </CustomerVisibleIndicator>
            ) : (
              col.value
            )}
          </span>
          <FontAwesomeIcon
            className={clsx(
              isDisabledBulkEditIcon || hasMailDraft
                ? 'gmawb-clickable-ui-disabled opacity-50 !cursor-not-allowed'
                : 'gmawb-clickable-ui'
            )}
            title="Bulk Edit"
            icon={faEdit}
            style={bulkEditIconStyle}
            onClick={() =>
              handlerType && !hasMailDraft ? handleBulkEditHandler(handlerType) : undefined
            }
          />
        </div>
      </>
    )
  }

  const flexTemplateColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const gmawbTemplateColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const statusColumnBodyTemplate = (rowData: PmrE2EProjectDetailsOrderlineModel) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return (
      <ProjectOrderlineStatusTemplate
        status={
          rowData[projectDetailsOrderlneListColumnStatus] ?? ProjectOrderlineStatus.NotDefined
        }
        orderlineDetail={rowData}
        reloadList={getList}
        projectId={props.projectId}
      ></ProjectOrderlineStatusTemplate>
    )
  }

  const flexProjectEcdColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    const projectOrderLines = orderLines.filter(
      line => line.flexProjectId === rowData.flexProjectId
    )
    const newestOrderlineECD = maxBy(projectOrderLines, row =>
      row.orderLineECD ? new Date(row.orderLineECD) : null
    )

    if (!isBulkActionRow(rowData)) {
      return (
        <PmrEcdSingleEditTemplate
          project={props.project}
          orderlineDetail={rowData}
          reloadList={onEcdUpdate}
          isOrderLineEcd={false}
        />
      )
    }
    return <></>
  }

  const ecdColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <Calendar
            yearRange={'2020:3000'}
            showButtonBar={true}
            monthNavigator={true}
            yearNavigator={true}
            showIcon={true}
            disabled={true}
          ></Calendar>
        </>
      )

    return (
      <PmrEcdSingleEditTemplate
        project={props.project}
        orderlineDetail={rowData}
        reloadList={onEcdUpdate}
        isOrderLineEcd={true}
      />
    )
  }

  const crcdColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <Calendar
            yearRange={'2020:3000'}
            showButtonBar={true}
            monthNavigator={true}
            yearNavigator={true}
            showIcon={true}
            disabled={true}
          ></Calendar>
        </>
      )
    return <span onClick={() => alert()}>{tableColumnBodyDefaultTemplate(rowData, col)}</span>
  }

  const priceColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <InputText disabled={true} />
        </>
      )

    if (!rowData.price || rowData.price === '-' || !rowData.currency) {
      return <></>
    }

    const formattedPrice = parseFloat(rowData.price).toFixed(2)
    const priceWithCurrency = `${formattedPrice} ${rowData.currency}`

    return (
      <>
        <span
          className={clsx(
            getProjectLineIsCompletedV2(rowData.orderLineStatus) &&
              classes['project-line-is-completed']
          )}
        >
          {priceWithCurrency}
        </span>
      </>
    )
  }

  const flexHandlerCollaboratorColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel
  ) => {
    if (isBulkActionRow(rowData)) return <></>
    return (
      <ProjectSingleCollaboratorAvatarReassign
        id={rowData.id}
        projectId={props.projectId}
        orderLineDescription={rowData.orderLineNumber ?? ''}
        name={get(rowData, projectDetailsOrderlneListColumnFlexHandler) ?? ''}
        email={get(rowData, projectDetailsOrderlneListColumnFlexHandlerEmail) ?? ''}
        orderLineStatus={
          rowData[projectDetailsOrderlneListColumnStatus] ?? ProjectOrderlineStatus.NotDefined
        }
        handlerType={HandlerType.FlexHandler}
        className={`${classes['project-detail-handler-container']}`}
        nonEditClassName={'gmawb-clickable-ui'}
        handlerEditState={handlerEditState}
        setHandlerEditState={setHandlerEditState}
        updateHandlers={updateHandlers}
        removeDropdownAppendToSelf={true}
        isEmailEditable={false}
        orderline={rowData}
      />
    )
  }

  const gmaWBHandlerCollaboratorColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel
  ) => {
    if (isBulkActionRow(rowData)) return <></>
    return (
      <ProjectSingleCollaboratorAvatarReassign
        id={rowData.id}
        projectId={props.projectId}
        orderLineDescription={rowData.orderLineNumber ?? ''}
        name={get(rowData, projectDetailsOrderlneListColumnGmaWbHandler) ?? ''}
        email={get(rowData, projectDetailsOrderlneListColumnGmaWbHandlerEmail) ?? ''}
        orderLineStatus={
          rowData[projectDetailsOrderlneListColumnStatus] ?? ProjectOrderlineStatus.NotDefined
        }
        handlerType={HandlerType.GmaWBHandler}
        className={classes['project-detail-handler-container']}
        handlerEditState={handlerEditState}
        setHandlerEditState={setHandlerEditState}
        updateHandlers={updateHandlers}
        removeDropdownAppendToSelf={true}
        isEmailEditable={true}
        orderline={rowData}
      />
    )
  }

  const certificationSchemeColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const applicationTypeSchemeColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const additionalInfoColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const deliveryPathColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const leadTimeColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <InputText disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const technologyColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <MultiSelect options={[]} placeholder="--Select--" disabled={true} />
        </>
      )
    return tableColumnBodyDefaultTemplate(rowData, col)
  }

  const ulRemarksColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData)) return <></>

    return (
      <ProjectOrderlineRemarksTemplate
        orderlineDetail={rowData}
        remarkType={RemarksTypesEnum.ULRemarks}
        latestRemarks={rowData.ulRemarks}
      />
    )
  }

  const customerRemarksColumnBodyTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => {
    if (isBulkActionRow(rowData))
      return (
        <>
          <InputText disabled={true} />
        </>
      )
    return (
      <ProjectOrderlineRemarksTemplate
        orderlineDetail={rowData}
        remarkType={RemarksTypesEnum.CustomerRemarks}
        latestRemarks={rowData.customerRemarks}
      />
    )
  }

  const invoicePriceTemplate = (
    rowData: PmrE2EProjectDetailsOrderlineModel,
    col: ColumnBodyOptions
  ) => <InvoicePriceTemplate col={col} rowData={rowData} project={props.project} />

  const invoicePriceHeaderTemplate = (col: GridColumnModel) => (
    <div
      className="d-flex"
      style={{
        alignItems: 'center',
      }}
    >
      <i className={classes['scroller']} id={`invoice-price-scroller-${props.projectId}`} />
      <span>Invoice Price</span>
      <div style={{ flexGrow: 1 }} />
      <FontAwesomeIcon
        className={clsx(
          { 'gmawb-clickable-ui': !isDisabledBulkEditIcon },
          { 'gmawb-clickable-ui-disabled': isDisabledBulkEditIcon }
        )}
        title="Bulk Edit"
        icon={faEdit}
        style={bulkEditIconStyle}
        onClick={() => {
          if (validSelectedRows().length > 0)
            setSelectedOrderLineIdInvoicePrice(validSelectedRows())
        }}
      />
    </div>
  )

  const orderlineECDHeaderTemplate = (col: GridColumnModel) => {
    return (
      <>
        <div className={`${classes['action-column-container']}`}>
          <span>Order Line ECD</span>
          <FontAwesomeIcon
            className={clsx(
              { 'gmawb-clickable-ui': !isDisabledBulkEditIcon },
              { 'gmawb-clickable-ui-disabled': isDisabledBulkEditIcon }
            )}
            title="Bulk-Edit Order Line ECDs."
            icon={faEdit}
            style={bulkEditIconStyle}
            onClick={() => {
              if (validSelectedRows()?.length > 0)
                setBulkEcdEditState(() => {
                  return {
                    isOrderlineECD: true,
                    isShowECDBulkEdit: true,
                  }
                })
            }}
          />
        </div>
      </>
    )
  }

  const flexProjectECDHeaderTemplate = (col: GridColumnModel) => {
    return (
      <>
        <div className={`${classes['action-column-container']}`}>
          <span>FLEX Project ECD</span>
          <FontAwesomeIcon
            className={clsx(
              { 'gmawb-clickable-ui': !isDisabledBulkEditIcon },
              { 'gmawb-clickable-ui-disabled': isDisabledBulkEditIcon }
            )}
            title="Bulk-Edit FLEX Project ECDs."
            icon={faEdit}
            style={bulkEditIconStyle}
            onClick={() => {
              if (validSelectedRows()?.length > 0)
                setBulkEcdEditState(() => {
                  return {
                    isOrderlineECD: false,
                    isShowECDBulkEdit: true,
                  }
                })
            }}
          />
        </div>
      </>
    )
  }

  const processColumnHeaderTemplates = (col: GridColumnModel) => {
    if (col.id === projectDetailsOrderlneListColumnCheckbox)
      return checkboxColumnHeaderTemplate(col)
    if (col.id === projectDetailsOrderlneListColumnAction) return actionColumnHeaderTemplate(col)
    if (col.id === projectDetailsOrderlneListColumnStatus) return statusColumnHeaderTemplate(col)
    if (col.id === projectDetailsOrderlineListColumnInvoicePrice)
      return invoicePriceHeaderTemplate(col)
    if (col.id === projectDetailsOrderlineListColumnFlexProjectEcd)
      return flexProjectECDHeaderTemplate(col)
    if (col.id === projectDetailsOrderlneListColumnEcd) return orderlineECDHeaderTemplate(col)
    if (
      col.id === projectDetailsOrderlneListColumnFlexHandler ||
      col.id === projectDetailsOrderlneListColumnGmaWbHandler
    )
      return handlersColumnHeaderTemplate(col)

    return tableColumnHeader(col)
  }

  const processColumnBodyTemplates = (col: GridColumnModel) => {
    if (col.id === projectDetailsOrderlneListColumnCheckbox)
      return checkboxColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnAction) return actionColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnFlexTemplate)
      return flexTemplateColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnGmawbTemplate)
      return gmawbTemplateColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnStatus) return statusColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlineListColumnFlexProjectEcd)
      return flexProjectEcdColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnEcd) return ecdColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnCrcd) return crcdColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnFlexHandler)
      return flexHandlerCollaboratorColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnGmaWbHandler)
      return gmaWBHandlerCollaboratorColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnCertificationScheme)
      return certificationSchemeColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnApplicationType)
      return applicationTypeSchemeColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnAdditionalInfo)
      return additionalInfoColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnDeliveryPath)
      return deliveryPathColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnLeadTime)
      return leadTimeColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnTechnology)
      return technologyColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnUlRemarks)
      return ulRemarksColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnCustomerRemarks)
      return customerRemarksColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlneListColumnPrice) return priceColumnBodyTemplate.bind(col)
    if (col.id === projectDetailsOrderlineListColumnInvoicePrice)
      return invoicePriceTemplate.bind(col)
    if (col.id === projectDetailsOrderlineListColumnOrderlineNumber)
      return orderlineNumberColumnBodyTemplate.bind(col)

    return tableColumnBody.bind(col)
  }

  const dynamicColumns = columns.map((col: GridColumnModel) => {
    const isCheckboxOrActionColumn =
      col.id === projectDetailsOrderlneListColumnCheckbox ||
      col.id === projectDetailsOrderlneListColumnAction
    return (
      <Column
        header={processColumnHeaderTemplates(col)}
        field={col.id}
        hidden={!col.isShown}
        className={col.id}
        style={
          col.isFlexWidth
            ? {
                flexGrow: 1,
                flexBasis: col.width,
                width: col.width,
                minWidth: col.minWidth ?? 80,
              }
            : {
                width: col.width,
                minWidth: col.isFrozen ? col.width : 50,
                maxWidth: isCheckboxOrActionColumn ? col.width : undefined,
              }
        }
        body={processColumnBodyTemplates(col)}
        sortable={col.orderBy != ''}
        align={col.align ?? 'left'}
        alignHeader={col.align ?? 'left'}
        reorderable={!col.isColumnNotReordable && !col.isFrozen}
        frozen={col.isFrozen}
      />
    )
  })

  const onColReorder = (e: DataTableColReorderParams) => {
    if (e.dropIndex < 2) {
      datatableRef.current.reset()
    } else {
      let prevNumber = 0
      let pwqColumns = columns
        .map((col, i) => {
          const cols: any = e.columns
          const orderNo = cols.findIndex((fi: any) => fi.props.field === col.id) + 1
          return {
            ...col,
            orderNo,
          }
        })
        .sort(function (a, b) {
          return a.orderNo - b.orderNo
        })
        .map(col => {
          if (col.orderNoShowHide! > 0) prevNumber++

          const orderNoShowHide = col.orderNoShowHide! > 0 ? prevNumber : 0

          return {
            ...col,
            orderNoShowHide,
          }
        })
        .sort(col => col.orderNoShowHide)
        .map(col => {
          if (col.orderNoShowHide <= selectOrderLineColumns!.frozenColumnCount) {
            return {
              ...col,
              isShown: true,
              isFrozen: true,
            }
          } else {
            return {
              ...col,
              isFrozen: false,
            }
          }
        })

      dispatch(
        updateShowHideColumnByTable({
          key: selectOrderLineColumns?.key,
          newColumns: pwqColumns,
          frozenCount: selectOrderLineColumns?.frozenColumnCount,
        })
      )
    }
  }

  const onColResize = (e: DataTableColumnResizeEndParams) => {
    let newColumns: any = columns.map((col, i) => {
      if (e.column.props.field == col.id) {
        return {
          ...col,
          width: e.element.offsetWidth,
        }
      } else {
        return col
      }
    })
    dispatch(
      updateShowHideColumnByTable({
        key: selectOrderLineColumns?.key,
        newColumns: newColumns,
      })
    )
  }

  const getRowUpdatingClassName = (rowData: PmrE2EProjectDetailsOrderlineModel) => {
    return clsx(isRowUpdating(rowData) && classes['is-updating'])
  }

  const handleOrderLineSetMismatchECD = async (rowData: PmrE2EProjectDetailsOrderlineModel) => {
    try {
      const result = await ProjectService.updateProjectLineIsMismatchECD(rowData.id)

      if (!result.isSuccess) return showError('Error', result.message)

      let data: MismatchECDDataModel = {
        flexProjectName: rowData.flexProjectName,
        projectNumber: rowData.projectNumber,
        orderLineECD: rowData.orderLineECD,
        orderLineNumber: rowData.orderLineNumber,
        previousECD: rowData.previousECD,
      }

      setMismatchECDData(data)
      setIsOrderlineMismatchECDDialogShow(true)
    } catch {
      showError('Error', 'There is an error processing your request. Please try again later.')
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const projectLineId = params.get('projectLineId')

    if (!projectLineId || !orderLines?.length) return

    const match = orderLines.find(x => x.id === projectLineId)

    if (match) {
      handleRowCheck({ checked: true } as any, match)
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, [orderLines])

  return (
    <>
      <div className={`${classes['table-container']}`}>
        <div className={`${classes['project-detail-orderline-list-grid-container']}`}>
          <DataTable
            ref={datatableRef}
            emptyMessage="--- No results found. Please try different search criteria or check your spelling. ---"
            dataKey="id"
            value={orderLines}
            loading={loading}
            scrollable
            resizableColumns
            size="small"
            scrollDirection="both"
            columnResizeMode="fit"
            reorderableColumns
            onColReorder={onColReorder}
            onColumnResizeEnd={onColResize}
            rowClassName={rowData => getRowUpdatingClassName(rowData)}
          >
            {dynamicColumns}
          </DataTable>
        </div>
      </div>

      {setIsBulkEditDialogShow && (
        <ProjectOrderlineStatusBulkEditDialog
          closeModal={() => setIsBulkEditDialogShow(false)}
          visible={isBulkEditDialogShow}
          selectedRows={validSelectedRows()}
          reloadList={getList}
          projectId={props.projectId}
        />
      )}

      {bulkEcdEditState.isShowECDBulkEdit && (
        <PmrBulkEcdEditDialog
          isOrderlineEcd={bulkEcdEditState.isOrderlineECD}
          visible={bulkEcdEditState.isShowECDBulkEdit}
          onHide={() =>
            setBulkEcdEditState(current => {
              return {
                ...current,
                isShowECDBulkEdit: false,
              }
            })
          }
          reloadList={getList}
          projectId={props.projectId}
          selectedRows={validSelectedRows()}
        />
      )}

      {showHandlerBulkDialogVisible?.isShowHandlerBulkEdit && (
        <PmrBulkHandlerReassignmentDialog
          visible={showHandlerBulkDialogVisible.isShowHandlerBulkEdit}
          handlerType={showHandlerBulkDialogVisible.handlerType!}
          projectId={props.projectId}
          orderLineIds={validSelectedRows().map(selectedRows => selectedRows.id)}
          onClose={() => {
            setShowHandlerBulkDialogVisible({
              isShowHandlerBulkEdit: false,
              handlerType: null,
            })
          }}
          getList={getList}
          resetSelectedLines={resetSelectedLines}
          isEmailEditable={showHandlerBulkDialogVisible.handlerType === HandlerType.GmaWBHandler}
          orderlines={validSelectedRows()}
        />
      )}

      {isOrderlineMismatchECDDialogShow && (
        <ProjectOrderlineMismatchECDDialog
          visible={isOrderlineMismatchECDDialogShow}
          onClose={() => setIsOrderlineMismatchECDDialogShow(false)}
          data={mismatchECDData}
        />
      )}

      {selectedOrderLineIdInvoicePrice.length > 0 && (
        <InvoicePriceModal
          data={selectedOrderLineIdInvoicePrice}
          visible={selectedOrderLineIdInvoicePrice.length > 0}
          onHide={() => setSelectedOrderLineIdInvoicePrice([])}
          project={props.project}
        />
      )}

      {targetOrderline && (
        <ManilaCoeTrackerForm
          visible={isDisplayManilaCoeTrackerForm}
          onHide={() => setDisplayManilaCoeTrackerForm(false)}
          handleUpdateTargetOrderline={handleUpdateTargetOrderline}
          {...targetOrderline}
        />
      )}
    </>
  )
}

export default ProjectDetailsOrderLineList
